import axios from 'axios'
import { API_URL } from 'config'

const request = axios.create({
  // baseURL: import.meta.env.VITE_API_URL || '',
  baseURL: API_URL || '',
  withCredentials: true,
})

request.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.replace(window.location.origin + '/')
      return Promise.reject(new Error('Unauthorized'))
    }
    return Promise.reject(error)
  },
)

// request.interceptors.request.use((config) => {
//   if (config.data) {
//     return {
//       ...config,
//       data: { data: config.data },
//     }
//   } else {
//     return config
//   }
// })

// request.interceptors.response.use(
//   (response) => {
//     return response.data.data
//   },
//   (error) => {
//     const e = error.response?.data.errors[0]
//     return Promise.reject(e.detail || e.title)
//   },
// )

export default request
